module.exports = __webpack_public_path__ + "static/media/Circo2024_24.02717caa.webp";